

import {_axios as axios} from  "../../plugins/axios.js";
import kit from "../../plugins/kit.js"

import { Message, MessageBox  } from "element-ui";
import i18nKit from "../../plugins/I18N.js"
// import Auth from "../../plugins/auth.js"

let api = kit.api;
let i18n = i18nKit.methods;
// let auth = Auth.methods;

export const doDelete = (selectes, finishCb) => {
    if(selectes.length>0){
        MessageBox.confirm('确定要删除选中的数据?', i18n.msg('提示'), {
            confirmButtonText: i18n.msg('是'),
            cancelButtonText: i18n.msg('否'),
            type: 'warning'
        }).then(() => {
            axios.post(api.inventoryIn.deletes
                +"?ids="+selectes.map(s => s.id).join(",")
            ).then((result) => {
                if(result.status){
                    if(finishCb)  finishCb();
                    Message( {
                        dangerouslyUseHTMLString: true,
                        message:Object.keys(result.data).map(key => key+":"+result.data[key]).join("<br/>")
                    })
                }else{
                    Message(result.msg);
                }
            });
        }).catch((err) => {
            Message(i18n.msg('取消操作'));
        });
    }
}

/**
 * 通过插件去其他平台抓取快递单号
 */
export const syncExpCode = (selectes, callback) => {


    let index = 0;
    for(let inv of selectes) {

        if(!inv.origin){
            Message("请选择状态是已采购且有采购平台的数据进行获取");
            // Message("第"+(index+1)+"条，没有采购平台");
            return;
        }
        
        if(!inv.purchaseCode){
            Message("请选择状态是已采购且有采购平台的数据进行获取");
            // Message("第"+(index+1)+"条，没有采购单号");
            return;
        }
        
        if(inv.status != 5){
            Message("请选择状态是已采购且有采购平台的数据进行获取");
            // Message("第"+(index+1)+"条，状态不是已采购");
            return;
        }
        index++;
    }

    let orders = selectes.map(s =>{ 
        let type = "";
        if(s.origin == "淘宝" || s.origin == "tb" || s.origin == "taobao"){
            type = "taobao";
        }else if(s.origin == "1688" || s.origin == "alibaba"){
            type = "alibaba"
        }else if(s.origin == "拼多多" || s.origin == "pdd"){
            type = "pdd";
        }
        return {type: type, id: s.purchaseCode}
    });

    window.OKK_Orders.queryTrackingNumber(orders, function(result){
        if(!result || result.length == 0){
            return;
        }

        // [
        //     [
        //         {
        //             "id": "2266840119288774406",
        //             "cpName": "百世快递",
        //             "mailNo": "557073528002490",
        //             "type": "alibaba"
        //         }
        //     ],
        // ]

        let codeMap = {};
        result.forEach(res => {
            if(res && res[0]){
                let val = res[0];
                codeMap[val.id] = val.mailNo;
            }
        });

        let param = {};
        selectes.forEach(inv => {
            let expCode = codeMap[inv.purchaseCode];
            param[inv.id] = expCode;
        });

        axios.post(api.inventoryIn.updateExpCode, 
            param
        ).then( (result) => {
            if(result.status){
                Message({
                    dangerouslyUseHTMLString: true,
                    message:Object.keys(result.data).map(key => key+":"+result.data[key]).join("<br/>")
                });
            }

            if(callback){
                callback();
            }

        });
    });
}